export type RegulatoryAnnouncement = {
  category: "regulatory" | "announcement" | "feature";
  id: number;
  subject: string;
  summary: string;
  link: string;
  isVisible: boolean;
  isNew: boolean;
  displayOrder: number;
  countryId?: number | null;
};

export type RegulatoryCountryCardConfig = {
  key: string | number;
  country: string;
  announcements: RegulatoryAnnouncement[];
};

export function createEmptyRegulatoryAnnouncement(): RegulatoryAnnouncement {
  return {
    category: "regulatory",
    id: 0,
    subject: "",
    summary: "",
    link: "",
    isVisible: true,
    isNew: false,
    displayOrder: 0,
    countryId: null,
  };
}
